<template>
	<div class="login-page">
		<div class="login">
			<div>
				<img src="@/assets/logo.png" alt="" class="logo" />
				<h3>Registro para organizadores de eventos</h3>
				<p>Accede a todos nuestros productos con un solo inicio de sesión en tu cuenta Tkt</p>

				<form @submit.prevent="login" class="mt-4">
					<div class="row">
						<div class="col-12">
							<FormulateForm v-model="form" @submit="login()">
								<FormulateInput
									class="mt-3"
									name="email"
									type="email"
									label="Email"
									placeholder="Ingrese su email"
									validation="required|email"
									:wrapper-class="['login-input']"
								/>

								<FormulateInput
									class="mt-3"
									label="Contraseña"
									name="password"
									type="password"
									placeholder="Ingrese su contraseña"
									validation="required"
								/>

								<div class="alert alert-danger text-white mt-4" v-if="loginError">
									{{ errorMessage }}
								</div>

								<button class="btn btn-primary btn-block btn-lg mt-4" type="submit">
									<span v-if="loading">Ingresando...</span>
									<span v-if="!loading">Ingresar</span>
								</button>
							</FormulateForm>

							<p class="text-center p-4">
								<small
									>Si tienes problemas para ingresar a tu cuenta, ponete en contacto con
									nosotros.</small
								>
							</p>
						</div>
					</div>
				</form>

				<div class="alert alert-default">
					<h5>¿No eres un promotor?</h5>
					<p>
						Si es un cliente que busca comprar boletos, ver un pedido, o descargar boletos, inicie sesión en
						su cuenta de tkt o comuníquese con Atención al cliente
					</p>
				</div>
			</div>
		</div>
		<div class="images">
			<div class="data"></div>
			<img src="@/assets/login-bk.jpeg" alt="" class="image-1" />
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import { onLogin } from "../vue-apollo"
import { mapMutations } from "vuex"
import mixins from "@/mixins/mixins"

export default {
	name: "Login",
	data() {
		return {
			form: {},
			loginError: false,
			loading: false,
			errorMessage: ""
		}
	},

	mixins: [mixins],
	methods: {
		...mapMutations(["authSuccess", "logout"]),
		login() {
			this.loginError = false
			this.errorMessage = ""
			if (!this.loading && this.email != "" && this.password != "") {
				this.loading = true

				return this.$apollo
					.mutate({
						mutation: gql`
							mutation userLogin($email: String!, $password: String!) {
								producerLogin(email: $email, password: $password) {
									token
									user {
										id
										name
										lastname
										email
										avatar {
											urlThumb
										}
									}
								}
							}
						`,
						variables: {
							email: this.form.email,
							password: this.form.password
						}
					})
					.then((data) => {
						console.log("login", data)
						let access_token = data.data.producerLogin.token
						let logged_user = data.data.producerLogin.user
						onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => {
							console.log("asds")
							this.authSuccess({
								token: access_token,
								loggedUser: logged_user
							})
							this.loading = false
							this.$emit("loadMe")
							this.$router.push("/")
						})
						this.loading = false
					})
					.catch((errors) => {
						// this.parseGQLErrors(errors)
						this.loading = false
						console.log(errors.graphQLErrors[0].message)
						this.loginError = true
						this.errorMessage = errors.graphQLErrors[0]
							? errors.graphQLErrors[0].message
							: "Error al iniciar sesion"
						this.loading = false
					})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.login-page {
	display: grid;
	grid-template-columns: 600px 1fr;
	background-color: #333;
}

.login {
	padding: 48px 96px;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 70vh;
	background: #fff;
	overflow-y: auto;

	.logo {
		display: block;
		width: 120px;
		margin-bottom: 96px;
	}
	h3 {
		font-size: 1.375rem;
		font-weight: 700;
		line-height: 1.3;
		margin: 0;
		margin-bottom: 12px;
	}
	p {
		font-size: 1rem;
	}
	.formulate-input {
		margin-bottom: 8px !important;
	}

	.btn {
		font-size: 16px;
		font-weight: 500;
		text-transform: uppercase;
	}
}

.images {
	position: relative;

	img {
		width: 100%;
		object-fit: cover;
		vertical-align: middle;
		object-position: 30% 0;
		height: 100vh;
	}

	.data {
		position: absolute;
		z-index: 100;
		top: auto;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 72px;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0, rgba(0, 0, 0, 0) 100%);
	}
}

.images:after {
	position: absolute;
	top: 0;
	right: 0;
	left: 0;

	bottom: 0;
	content: "";
	background: linear-gradient(45deg, rgba(0, 0, 0, 0.8) 0, rgba(0, 0, 0, 0.5) 35%, rgba(0, 0, 0, 0) 100%);
}

.alert-default {
	padding: 24px;
	background-color: #f8f8f8;
	border-radius: 6px;

	h5 {
		font-size: 1.1rem;
	}
	p {
		font-size: 0.9rem;
		margin: 0px;
	}
}
</style>
